export const erknmFieldsMarkedAsRequired: string[] = [
  'knoOrganizationErknm',
  'prosecutorOrganizationErknm',
  'kindControl',
  'typeErknm',
  'reasonsErknm[{id}].type',
  'reasonsErknm[{id}].riskIndicators',
  'reasonsErknm[{id}].riskIndicators[{id}].riskIndicator',
  'reasonsErknm[{id}].riskIndicators[{id}].indicatorRiskAttachment',
  'reasonsErknm[{id}].text',
  'reasonsErknm[{id}].textReactQuillEditor',
  'reasonsErknm[{id}].dateRequirement',
  'reasonsErknm[{id}].requirementDetails',
  'reasonsErknm[{id}].order',
  'reasonsErknm[{id}].links',
  'reasonsErknm[{id}].passportLinks',
  'reasonsErknm[{id}].violationEvidences[{id}].link',
  'reasonsErknm[{id}].date',
  'reasonsErknm[{id}].lastConductedKnmDate',
  'reasonsErknm[{id}].programNumber',
  'reasonsErknm[{id}].programAttachment',
  'reasonDocuments[{id}].type',
  'reasonDocuments[{id}].attachments',
  'reasonDocuments[{id}].violationEvidences',
  'reasonDocuments[{id}].violationEvidences[{id}].date',
  'reasonDocuments[{id}].violationEvidences[{id}].link',
  'reasonDocuments[{id}].violationEvidences[{id}].description',
  'approvedOnPaperDocuments.attachments',
  'approveRequired',
  'kindKnm',
  'startDate',
  'startTime',
  'stopDate',
  'stopTime',
  'objectsErknm[{id}].objectType',
  'objectsErknm[{id}].address',
  'objectsErknm[{id}].manualAddress',
  'objectsErknm[{id}].region',
  'objectsErknm[{id}].objectKind',
  'objectsErknm[{id}].objectSubKind',
  'objectsErknm[{id}].riskCategory',
  'objectsErknm[{id}].dangerClass',
  'organizations[{id}].subjectType',
  'organizations[{id}].inn',
  'organizations[{id}].snils',
  'organizations[{id}].kpp',
  'organizations[{id}].rafpNza',
  'organizations[{id}].country',
  'organizations[{id}].document',
  'inspectorsErknm[{id}].fullName',
  'inspectorsErknm[{id}].position',
  'collaboratingOrganizationsErknm',
  'collaboratingOrganizationsErknm[{id}].organization',
  'interactionCategory',
  'videoCallInfo',
  'videoCallInfo[{id}].link',
  'videoCallInfo[{id}].dateTime',
  'eventsErknm[{id}].type',
  'eventsErknm[{id}].interactionCategory',
  'eventsErknm[{id}].startDate',
  'eventsErknm[{id}].stopDate',
  'eventsErknm[{id}].submittedDocuments[{id}].documentTitle',
  'eventsErknm[{id}].submittedDocuments[{id}].requestDateTime',
  'eventsErknm[{id}].submittedDocuments[{id}].submissionDeadline',
  'eventsErknm[{id}].submittedDocuments[{id}].submissionDateTime',
  'eventsErknm[{id}].submittedDocuments[{id}].files',
  'docTarget[{id}].docTargetType',
  'docTarget[{id}].ervkControlKindDocTarget',
  'docTarget[{id}].file',
  'places[{id}].value',
  'places[{id}].manualAddress',
  'places[{id}].region',
  'checklistsErknm',
  'checklistsErknm[{id}].checkList',
  'checklistsErknm[{id}].ervkCheckList',
  'checklistsErknm[{id}].questions',
  'checklistsErknm[{id}].questions[{id}].title',
  'subjectNotifications[{id}].type',
  'subjectNotifications[{id}].date',
  'subjectNotifications[{id}].comment',
  'approved',
  'approveNumberDecision',
  'approveDateDecision',
  'approveFioSigner',
  'approveTitleSigner',
  'approveFile',
  'rejectReasonType',
  'approveNote',
  'acts[{id}].typeAct',
  'acts[{id}].holdingDateTime',
  'acts[{id}].durationDays',
  'acts[{id}].durationHours',
  'acts[{id}].knoInspectors',
  'acts[{id}].organizationTemplate',
  'acts[{id}].organization.subjectType',
  'acts[{id}].organization.inn',
  'acts[{id}].organization.organizationName',
  'acts[{id}].organization.snils',
  'acts[{id}].organization.kpp',
  'acts[{id}].organization.rafpNza',
  'acts[{id}].organization.country',
  'acts[{id}].organization.document',
  'acts[{id}].canceledReason',
  'acts[{id}].canceledReasonDescription',
  'acts[{id}].canceledReasonDescriptionReactQuillEditor',
  'acts[{id}].document.attachments',
  'acts[{id}].events',
  'acts[{id}].events[{id}].type',
  'acts[{id}].events[{id}].startDate',
  'acts[{id}].events[{id}].stopDate',
  'acts[{id}].events[{id}].linkVks',
  'acts[{id}].events[{id}].inspectors',
  'acts[{id}].events[{id}].inspectors[{id}].fullName',
  'acts[{id}].events[{id}].protocol.file.attachments',
  'acts[{id}].events[{id}].uavTechnologies',
  'acts[{id}].events[{id}].uavTechnologies[{id}].type',
  'acts[{id}].events[{id}].uavTechnologies[{id}].name',
  'acts[{id}].isViolatedMandatoryRequirements',
  'acts[{id}].violatedMandatoryRequirements',
  'acts[{id}].violatedMandatoryRequirements[{id}].violatedMandatory',
  'acts[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].category',
  'acts[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations',
  'acts[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].title',
  'acts[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].descriptionReactQuillEditor',
  'acts[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].repeatCorrected',
  'acts[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].repeatCorrectedInEvent',
  'acts[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes',
  'acts[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type',
  'acts[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type[{id}].value',
  'acts[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterial',
  'acts[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterialReactQuillEditor',
  'acts[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].method',
  'acts[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments',
  'acts[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments[{id}].link.value',
  'acts[{id}].isViolationResolvedNote',
  'acts[{id}].fioReader',
  'acts[{id}].titleReader',
  'acts[{id}].knoInspectors[{id}].knoInspector',
  'acts[{id}].acquaintanceLackType',
  'acts[{id}].refuserFio',
  'acts[{id}].refuserTitle',
  'acts[{id}].fioAndPositionSinger',
  'acts[{id}].familiarizationNotifications[{id}].knmNoticeType',
  'acts[{id}].familiarizationNotifications[{id}].noticeDate',
  'acts[{id}].remarks[{id}].text',
  'acts[{id}].remarks[{id}].textReactQuillEditor',
  'acts[{id}].remarks[{id}].signerFullName',
  'acts[{id}].remarks[{id}].signerPosition',
  'acts[{id}].remarks[{id}].date',
  'resultDecisions[{id}].kindDecision',
  'resultDecisions[{id}].numberDecision',
  'resultDecisions[{id}].dateDecision',
  'resultDecisions[{id}].injunction.note',
  'resultDecisions[{id}].injunction.noteReactQuillEditor',
  'resultDecisions[{id}].violatedMandatoryRequirements',
  'resultDecisions[{id}].fioSigner',
  'resultDecisions[{id}].titleSigner',
  'resultDecisions[{id}].isProsecution',
  'resultDecisions[{id}].responsibleEntities',
  'resultDecisions[{id}].responsibleEntities[{id}].organization',
  'resultDecisions[{id}].responsibleEntities[{id}].organization.value.subjectType',
  'resultDecisions[{id}].responsibleEntities[{id}].organization.value.organizationName',
  'resultDecisions[{id}].responsibleEntities[{id}].organization.value.inn',
  'resultDecisions[{id}].responsibleEntities[{id}].organization.value.position',
  'resultDecisions[{id}].responsibleEntities[{id}].organization.value.document',
  'resultDecisions[{id}].responsibleEntities[{id}].organization.value.snils',
  'resultDecisions[{id}].responsibleEntities[{id}].organization.value.kpp',
  'resultDecisions[{id}].responsibleEntities[{id}].organization.value.rafpNza',
  'resultDecisions[{id}].responsibleEntities[{id}].organization.value.country',
  'resultDecisions[{id}].responsibleEntities[{id}].responsibilityType',
  'resultDecisions[{id}].responsibleEntities[{id}].structuresNPA',
  'resultDecisions[{id}].protocol.attachments',
  'resultDecisions[{id}].violatedMandatoryRequirements',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].category',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanExplanations',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanMethodsRequired',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanExplanationsRequired',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanDates[{id}].value',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].title',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixFactMethod',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].method',

  'stpNumber',
  'planId',
  'agreements[{id}].prescription',
  'agreements[{id}].violations',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixFactMethod',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type[{id}].value',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterial',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterialReactQuillEditor',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].method',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments[{id}].link.value',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].grade',
  'agreements[{id}].petitionOrganizationType',
  'agreements[{id}].petitionAttachment',
  'agreements[{id}].petitionOrganization.inn',
  'agreements[{id}].petitionOrganization.ogrn',
  'agreements[{id}].petitionOrganization.snils',
  'agreements[{id}].petitionOrganization.subjectType',
  'agreements[{id}].petitionOrganization.organizationName',
  'agreements[{id}].petitionOrganization.factualAddress',
  'agreements[{id}].petitionOrganization.locationAddress',
  'agreements[{id}].petitionOrganization.country',
  'agreements[{id}].petitionOrganization.rafpNza',
  'agreements[{id}].petitionOrganization.kpp',
  'agreements[{id}].petitionOrganization.document',
  'agreements[{id}].petitionOrganization.locationAddress',
  'agreements[{id}].approvalOfAgreement',
  'agreements[{id}].approvalOfAgreementAttachment',
  'agreements[{id}].eliminateViolationsNumber',
  'agreements[{id}].conclusionDate',
  'agreements[{id}].termOfExecutionAgreement',
  'agreements[{id}].eliminateViolationsAttachment',
  'agreements[{id}].applicationForConsiderationAttachment',
  'agreements[{id}].violationCorrectionProgramAttachments',
  'agreements[{id}].fioSigner',
  'agreements[{id}].titleSigner',
  'agreements[{id}].approveInfo.note',
  'agreements[{id}].approveInfo.approved',
  'agreements[{id}].approveInfo.numberDecision',
  'agreements[{id}].approveInfo.dateDecision',
  'agreements[{id}].approveInfo.whoMadeDecision',
  'agreements[{id}].approveInfo.titleSigner',
  'agreements[{id}].approveInfo.attachment',
  'agreements[{id}].terminate.terminationReasons',
  'agreements[{id}].terminate.decisionTerminationAttachment',
  'agreements[{id}].terminate.titleSigner',
  'agreements[{id}].terminate.titleSigner.label',
  'agreements[{id}].terminate.fioSigner',
  'agreements[{id}].execution.decision',
  'agreements[{id}].execution.executionDate',
  'agreements[{id}].execution.titleSigner',
  'agreements[{id}].execution.fioSigner',
  'agreements[{id}].changes[{id}].types',
  'agreements[{id}].changes[{id}].types[{id}].type',
  'agreements[{id}].changes[{id}].reasons',
  'agreements[{id}].changes[{id}].reasons[{id}]',
  'agreements[{id}].changes[{id}].attachment',
  'agreements[{id}].changes[{id}].termOfExecutionAgreement',
  'agreements[{id}].changes[{id}].updatedAgreementAttachment',
  'agreements[{id}].changes[{id}].petitionAttachment',
  'agreements[{id}].changes[{id}].titleSigner',
  'agreements[{id}].changes[{id}].fioSigner',
  'takenMeasures',
  'changePlanReason[{id}].approvedChangePlanErknm',
  'changePlanReason[{id}].approveChangePlanDateDecision',
  'changePlanReason[{id}].approveChangePlanFioSigner',
  'changePlanReason[{id}].approveChangePlanTitleSigner',
  'changePlanReason[{id}].approveChangePlanFile',
  'resultDecisions[{id}].subject.inn',
  'resultDecisions[{id}].subject.organizationName',
  'resultDecisions[{id}].subject.country',
  'resultDecisions[{id}].founder.inn',
  'resultDecisions[{id}].founder.organizationName',
  'resultDecisions[{id}].founder.country',
];
